import fillInGapTimespan from "components/pages/schedule/helpers/fillInGapTimespan";
import OverlappingPlannedBreaks from "components/pages/schedule/helpers/OverlappingPlannedBreaks";
import Block from "domain/Block";
import EventTypes from "hooks/apollo/usageData/EventTypes";
import DateTime from "utils/DateTime";

export default function dropToReschedule({ gapFiller, onRescheduleBlocks, onTrackUsage }) {
  return ({ eventRecords, valid, context }) => {
    if (!valid) {
      gapFiller.clearDragState();

      return;
    }

    if (isMultiScheduling({ eventRecords })) {
      gapFiller.clearDragState();
    }

    const blocks = eventRecords.map((eventRecord) => {
      const { data: blockData } = eventRecord;
      const draggedEntity = context.draggedEntities.find((entity) => entity.resourceId === blockData.resourceId);
      const line = draggedEntity?.resource;

      if (!line) {
        gapFiller.clearDragState();

        return null;
      }

      const updatedBlockData = adjustTimespan({ blockData, gapFiller, line });

      const lineId = line.id;
      const updatedBlock = Block.updateBlock(blockData.block, {
        endsAt: DateTime.toISO8601(updatedBlockData.endDate),
        startsAt: DateTime.toISO8601(updatedBlockData.startDate),
      });

      eventRecord.setStartDate(updatedBlockData.startDate);
      eventRecord.setEndDate(updatedBlockData.endDate);
      eventRecord.commitAsync();

      const isInFuture = DateTime.isInTheFuture(updatedBlock.startDate);
      const isInProgressOrFuture = DateTime.isInTheFuture(updatedBlock.endDate);

      return {
        ...updatedBlock,
        line: { id: lineId },
        lineEfficiency: isInFuture ? line.efficiency : updatedBlock.lineEfficiency,
        overlappingPlannedBreaks: isInProgressOrFuture
          ? OverlappingPlannedBreaks.calculateOverlappingPlannedBreaks(line, updatedBlock.startsAt, updatedBlock.endsAt)
          : updatedBlock.overlappingPlannedBreaks,
      };
    });

    onRescheduleBlocks(blocks);

    if (gapFiller.isActive()) {
      onTrackUsage(EventTypes.FILL_IN_GAP);
    }

    gapFiller.clearDragState();
  };
}

function isMultiScheduling({ eventRecords }) {
  return eventRecords.length > 1;
}

function adjustTimespan({ gapFiller, blockData, line }) {
  const { block, startDate: startTime, endDate: endTime } = blockData;
  const timespanWithinBlock = {
    endTime,
    startTime,
  };

  const timespanWithinGap = fillInGapTimespan({ block, gapFiller, line: line.data });

  const timespan = timespanWithinGap || timespanWithinBlock;

  return { ...blockData, endDate: timespan.endTime, startDate: timespan.startTime };
}
